<div class="container text-center">
    <div class="card">
        <div class="card-header text-center">
            <h1>Public Records</h1>
        </div>
        <div class="card-body">
            <div class="record-row text-left">
                <h3>RentWise Education:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/rentwise-records'">View Records</button>
            </div>
            <br>
            <div class="record-row text-left">
                <h3>Housing Provider Education:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/fhe-records'">View Records</button>
            </div>
            <br>
            <div class="record-row text-left">
                <h3>Properties:</h3>
                <button type="button" class="btn waves-dark" [routerLink]="'/properties-records'">View Records</button>
            </div>
        </div>
    </div>
</div>
